import { Flex, smBumps, Typo, xsBumps } from '@wrisk/ui-components'
import React from 'react'

import {
  getPolicyVersion,
  PolicyVersion,
  SelectVoluntaryExcessChange,
} from '../../../../../../../../domain'
import { isVoluntaryExcess, useExcesses } from '../../../../../../../../hooks/excess'
import {
  tDefaults,
  tFormats,
  useWriskTranslation,
} from '../../../../../../../../infrastructure/internationalisation'
import { usePolicy } from '../../../../../PolicyProvider'

interface Props {
  change: SelectVoluntaryExcessChange
  updatedPolicyVersion: PolicyVersion
}

const ExcessChangesItem: React.FC<Props> = ({ change, updatedPolicyVersion }) => {
  const { t } = useWriskTranslation()

  const { policy } = usePolicy()

  const { quote: originalQuote } = getPolicyVersion(policy)
  const { voluntary: originalVoluntary } = useExcesses(originalQuote)

  const original = originalVoluntary.find(isVoluntaryExcess(change.excessCode))

  const { quote: updatedQuote } = updatedPolicyVersion
  const { voluntary: updatedVoluntary } = useExcesses(updatedQuote)

  const updated = updatedVoluntary.find(isVoluntaryExcess(change.excessCode))

  return (
    <Flex mx={2} p={smBumps}>
      <Typo fontWeight='bold' mr={2}>
        {t(tDefaults('product.headers.voluntary-excess'))}
      </Typo>
      <Flex>
        <Typo color='inactive' mr={xsBumps}>
          <s>{t(tFormats('currency.short'), { amount: original?.excess })}</s>
        </Typo>
        <Typo>{t(tFormats('currency.short'), { amount: updated?.excess })}</Typo>
      </Flex>
    </Flex>
  )
}

export default ExcessChangesItem
